import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ze } from 'utils/zhEn';
import style from 'components/exception/issue/ReportDetail/style.scss';
import IssueJankFlamePanel from 'components/exception/issue/DataHead/IssueJankFlamePanel';
import { buildFlameGraphFromJankV2Samples } from 'utils/jankFlameGraphMerge';

/**
 * 上报详情里的卡顿采样火焰图。
 * 单条树由附件 jankV2_samples.json（redux jankSampleStackInfo）现算。
 * 线上 queryAppDetailCrash 没有 jankSampleFlameGraphJson 字段；若以后带上，优先用那棵树。
 */
function parseJankSampleFlameGraphJson(jankSampleFlameGraphJson) {
  if (!jankSampleFlameGraphJson) {
    return null;
  }
  try {
    const data = typeof jankSampleFlameGraphJson === 'string'
      ? JSON.parse(jankSampleFlameGraphJson)
      : jankSampleFlameGraphJson;
    if (!data || !data.value) {
      return null;
    }
    return data;
  } catch (e) {
    console.error('parse jankSampleFlameGraphJson failed.', e);
    return null;
  }
}

const ReportJankSampleFlameGraph = ({ issue, appId, pid }) => {
  const view = useMemo(() => {
    if (!issue) {
      return null;
    }
    const issueObj = typeof issue.toJS === 'function' ? issue.toJS() : issue;
    const { appDetailCrashInfo, jankSampleStackInfo, crashDoc } = issueObj || {};
    const prepared = parseJankSampleFlameGraphJson(appDetailCrashInfo?.jankSampleFlameGraphJson);
    const fromSamples = buildFlameGraphFromJankV2Samples(jankSampleStackInfo);
    const singleTree = prepared || fromSamples;
    if (!singleTree) {
      return null;
    }
    const crashMap = (crashDoc && crashDoc.crashMap) || {};
    return {
      singleTree,
      issueId: crashMap.issueId,
      crashId: crashMap.crashId || crashMap.id,
    };
  }, [issue]);

  if (!view) {
    return null;
  }

  return (
    <ul>
      <li style={{ width: '100%' }}>
        <p className={style.label}>{ze('卡顿火焰图', 'Jank Flame Graph')}</p>
        <IssueJankFlamePanel
          singleTree={view.singleTree}
          appId={appId}
          pid={pid}
          issueId={view.issueId}
          crashId={view.crashId}
          fetchSamples
          minBlockHeight={20}
          maxHeight={300}
          rootOnTop
        />
      </li>
    </ul>
  );
};

ReportJankSampleFlameGraph.propTypes = {
  issue: PropTypes.object,
  appId: PropTypes.string,
  pid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ReportJankSampleFlameGraph;
